import { PaginatedDtoSchema } from "@core/data/dto/paginated.dto.ts";
import { ReportStationSummaryDtoSchema } from "@report/data/dto/report-station.dto.ts";
import * as z from "zod";

const ReportStatsDtoSchema = z.record(
    z.string(),
    z.record(
        z.string(),
        z.object({
            max: z
                .object({
                    value: z.number(),
                    timestamp: z.number(),
                })
                .nullable(),
            min: z
                .object({
                    value: z.number(),
                    timestamp: z.number(),
                })
                .nullable(),
            avg: z.number().nullable(),
            sum: z.number().nullable(),
        }),
    ),
);

const ReportDataDtoSchema = z
    .object({
        timestamp: z.number(),
    })
    .catchall(z.nullable(z.union([z.number(), z.string().trim()])))
    .readonly();

const ReportStationDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.array(ReportDataDtoSchema),
        station: ReportStationSummaryDtoSchema,
        pagination: PaginatedDtoSchema,
        stats: ReportStatsDtoSchema.optional(),
    })
    .readonly();

export const ReportDtoSchema = z
    .object({
        // eslint-disable-next-line id-denylist
        data: z.record(z.string(), ReportStationDtoSchema), // Station ID as key
    })
    .readonly();

export type ReportDto = z.output<typeof ReportDtoSchema>;

export interface ReportHistoricalFilterQuery {
    from: number;
    to: number;
    station_ids: number[];
}

export interface ReportHistoricalFilterBody {
    variable_ids?: number[];
    road?: string;
    from_pk?: number;
    to_pk?: number;
    origin_poi?: string;
    max_values?: boolean;
    min_values?: boolean;
    avg_values?: boolean;
    sum_values?: boolean;
    measures?: boolean;
    total_sum?: boolean;
    tendency?: boolean;
}

export interface ReportHistoricalCustomFilterBody {
    road?: string;
    from_pk?: number;
    to_pk?: number;
}
